import { Reveal } from "../components/site/Reveal";
import ProjectCarousel from "../components/site/ProjectCarousel";
import { projects } from "../data/projects";

export default function ProjectsPage() {
  return (
    <div data-testid="projects-page" className="pt-32 pb-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
            — Portfolio
          </div>
          <h1 className="mt-4 font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-zinc-100 leading-[1.02]">
            Projects.
          </h1>
          <p className="mt-6 text-zinc-400 text-lg max-w-2xl leading-relaxed">
            A selection of recent builds — architect-led collaborations and
            direct client engagements across Victoria.
          </p>
        </Reveal>

        <div className="mt-20 space-y-32">
          {projects.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.05}>
              <article
                data-testid={`projects-list-card-${p.slug}`}
                className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 items-end"
              >
                <div
                  className={`col-span-1 ${
                    i % 2 === 0 ? "md:col-span-8" : "md:col-span-8 md:order-2"
                  }`}
                >
                  <ProjectCarousel
                    photos={p.photos}
                    title={p.title}
                    testId={`project-carousel-${p.slug}`}
                  />
                </div>
                <div
                  className={`col-span-1 md:col-span-4 ${
                    i % 2 === 0 ? "" : "md:order-1"
                  }`}
                >
                  <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
                    {p.category} · {p.year}
                  </div>
                  <h2 className="mt-4 font-serif text-3xl sm:text-4xl tracking-tight text-zinc-100">
                    {p.title}
                  </h2>
                  <div className="mt-3 text-zinc-500 text-sm tracking-wide">
                    {p.location}
                  </div>
                  {p.summary ? (
                    <p className="mt-6 text-zinc-400 leading-relaxed">
                      {p.summary}
                    </p>
                  ) : null}
                  <div className="mt-6 text-[11px] tracking-[0.25em] uppercase text-zinc-500">
                    {p.photos.length} photos
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
